export function retryDelay(error, now=Date.now()) {
  const headers=error.response?.headers;
  const value=headers?.['retry-after']??headers?.get?.('retry-after');
  if(value!==undefined&&value!==null&&String(value).trim()!==''){
    const seconds=Number(value);
    if(Number.isFinite(seconds)&&seconds>=0)return Math.min(3600,Math.max(1,Math.ceil(seconds)));
    const at=Date.parse(String(value));
    if(Number.isFinite(at))return Math.min(3600,Math.max(1,Math.ceil((at-now)/1000)));
  }
  return 30;
}
export function chatErrorMessage(error) {
  if(error.response?.status===429)return `The assistant has reached its request limit or is busy. Please wait ${retryDelay(error)} seconds before trying again.`;
  return error.response?.data?.message||'Unable to answer. Please retry or use the manual patient tools below.';
}
